import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { css } from "styled-components"
import { Grid, Block, Spacer } from "../../atoms/layout-primitives"
import FeatureGrid from "../../organisms/feature-grid"
import SectionDivider from "../../../components/shared/section-divider"
import VariantContainer from "../../atoms/variant-container"
import FadedTitle from "../../../components/shared/faded-title"
import Button from "../../atoms/button"

export default function IPStypes() {
  const query = useStaticQuery(graphql`
    query {
      beaconIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/icons/beacon.svg"
        }
      ) {
        publicURL
      }
      interialIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/icons/interial.svg"
        }
      ) {
        publicURL
      }
      proximityIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/icons/proximity.svg"
        }
      ) {
        publicURL
      }
      sensorBasedIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/icons/sensor based.svg"
        }
      ) {
        publicURL
      }
      sensorFusionIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/icons/sensor fusion.svg"
        }
      ) {
        publicURL
      }
      wifiIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/icons/wifi.svg"
        }
      ) {
        publicURL
      }
      technologyFade: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/faded title dark.svg"
        }
      ) {
        publicURL
      }
    }
  `)

  const GridItems = [
    {
      icon: query.wifiIcon.publicURL,
      title: "WiFi-based Systems",
      text: `Apple's IPS utilizes the radio frequency (RF) patterns of your Wi-Fi access points enabling an infrastructure-free solution. This technology achieves GPS-level accuracy in indoor spaces by simply performing an RF survey of your venue.`,
    },
    {
      icon: query.beaconIcon.publicURL,
      title: "Beacons",
      text: `Apple and Google released Bluetooth Low Energy (BLE) specifications for iBeacons and Eddystone beacons, respectively. These offer similar proximity to WiFi access point providers.`,
    },
    {
      icon: query.proximityIcon.publicURL,
      title: "Proximity-based Systems",
      text: `Existing Wi-Fi access point providers (APs) like Cisco and Aruba have added geofencing and proximity capabilities to their enterprise offering. Users on the network running an enabled application can determine their rough location indoors.`,
    },
    {
      icon: query.sensorBasedIcon.publicURL,
      title: "Sensor-based Systems",
      text: `Sensors can be added to your venue to locate Wi-Fi and Bluetooth/BLE along with cellular signals to enhance the WiFi-based location systems. This can help to increase the overall accuracy of your positioning system, however, comes with an added hardware cost.`,
    },
    {
      icon: query.interialIcon.publicURL,
      title: "Intertial Navigation",
      text: `Onboard motion sensors built into every cell phone estimate user positions by sensing physical motion and last known position.`,
    },
    {
      icon: query.sensorFusionIcon.publicURL,
      title: "Sensor Fusion",
      text: `Sensor Fusion combines multiple of these positioning services to provide an even more accurate experience.`,
    },
  ]

  return (
    <>
      <SectionDivider />
      <VariantContainer
        variants={[
          css`
            background-color: var(--tricorn-black);
          `,
        ]}
      >
        <Grid>
          <Block
            variants={[
              css`
                & h3 {
                  color: var(--dark-mode-body-grey);
                }
                margin-top: 48px;
                text-align: center;
                grid-column: 1 / -1;
              `,
              css`
                grid-column: 2 / -2;
              `,
              css`
                margin-top: 128px;
                grid-column: 3 / -3;
              `,
            ]}
          >
            <FadedTitle
              title="Different Types of Indoor Positioning Systems"
              image={query.technologyFade.publicURL}
              alt="Technology"
              fadeSettings={{
                lg: "center",
              }}
              textAlign={{ sm: "center", md: "center", lg: "center" }}
            />
          </Block>
          <Spacer height={{ sm: "72px", md: "64px", lg: "96px" }} />
          <FeatureGrid items={GridItems} />
          <Button.ScrollLink to="contact-form" smooth duration={1000}
            variants={[
              css`
                justify-self: center;
                margin-top: 32px;
                grid-column: 1 / -1;  
              `,
              css``,
              css`
                margin-top: 64px;
              `
            ]}
          >
            Book A Demo
          </Button.ScrollLink>
          <Spacer height={{ sm: "48px", md: "48px", lg: "64px" }} />
        </Grid>
      </VariantContainer>
      <SectionDivider flip />
    </>
  )
}
